module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "name": "demo-chart-pie"
    }
  }, [_vm._v("\n\tchart pie\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f9aac454!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/demo/demoChartPie.vue
// module id = 4016
// module chunks = 1